export class ApplicationIncomeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getIncomes({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/income`);
  }

  async deleteIncome({ applicationId, incomeId, tabId, withLoanOptionId }) {
    return this.#http.delete(`/application/${applicationId}/income/${incomeId}`, {
      params: { tabId, withLoanOptionId },
    });
  }

  async createIncome({ applicationId, borrowerId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/borrower/${borrowerId}/income`, body, {
      params: { withLoanOptionId },
    });
  }

  async editIncome({ applicationId, borrowerId, withLoanOptionId, incomeId, ...body }) {
    return this.#http.put(
      `/application/${applicationId}/borrower/${borrowerId}/income/${incomeId}`,
      body,
      {
        params: { withLoanOptionId },
      },
    );
  }

  async updateIncomes({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/incomes`, body, {
      params: { withLoanOptionId },
    });
  }
}
